
const renameFolderButton = jQuery('div.designGridItem-Rename'),
        renameFolderForms = jQuery('form.designGridItem-form'),
        submitRenameForm = jQuery('div.designGridItem-Change',renameFolderForms),
        cancelFolderRename = jQuery('div.designGridItem-Cancel',renameFolderForms);

renameFolderButton.unbind('click');
renameFolderButton.bind('click',function () {
    renameFolderForms.removeClass('active');
    const $this = jQuery(this);
    jQuery('form.designGridItem-form',$this.parent()).addClass('active');
    $this.parent('li').find('input.foldersGridItem-input').focus();
});

$(document).on('click', function (e) {
    if ($(e.target).closest("div.designGridItem-Rename").length === 0) {
        renameFolderForms.removeClass('active');
    }
});

submitRenameForm.unbind('click');
submitRenameForm.bind('click',function () {
    jQuery(this).parent('form').submit();
});

cancelFolderRename.unbind('click');
cancelFolderRename.bind('click',function () {
    jQuery(this).parent('form').removeClass('active');
});



